import Typography from "@mui/material/Typography";

export default function PageNotFound() {

    return <Typography>This is not the page you're looking for...</Typography>
    
}